import { Col, Row, Modal, Input, Form } from "antd";
import "./itemstyle.css";
import { Composition } from "./Composition";
import { Toppings } from "./Toppings";
import { Prices } from "./Price";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { mainActions } from "../../../../store/main/mainSlice";

export interface Specification {
  isComponent: boolean;
  specificationId: number;
  id: number;
  extraCharge: number;
  quantity: number;
  notes: string;
}

interface SaleItem {
  localId: number;
  name: string;
  itemId: number;
  barcode: string;
  price: number;
  isTaxable: boolean;
  tax: number;
  discount: null | number;
  notes: string;
  qty: number;
  specifications: Specification[];
}

type itempos = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItem: SaleItem;
};
const Item = ({ isOpen, setIsOpen, selectedItem }: itempos) => {
  const [t] = useTranslation("common");
  const [specifications, setSpecifications] = useState<Specification[]>(
    selectedItem?.specifications
  );
  const allItems = useSelector((state: any) => state.main.items);
  const selectedItemId = useSelector((state: any) => state.main.selectedItem);
  const item = allItems.find((i: any) => i.localId === selectedItemId);
  const [extrasTotalPrice, setExtrasTotalPrice] = useState(
    (item?.specifications &&
      item?.specifications.length > 0 &&
      item?.specifications.reduce(
        (accumulator: number, specification: { extraCharge: number }) => {
          return accumulator + specification.extraCharge;
        },
        0
      )) ||
      0
  );

  useEffect(() => {
    let total = 0;
    if (specifications && specifications.length > 0) {
      total = specifications.reduce(
        (accumulator: number, specification: { extraCharge: number }) => {
          return accumulator + specification.extraCharge;
        },
        0
      );
    }
    setExtrasTotalPrice(total);
  }, [specifications]);
  useEffect(() => {
    setSpecifications(selectedItem?.specifications);
  }, [selectedItem]);
  const dispatch = useDispatch();
  return (
    <>
      <Modal
        centered
        maskClosable={false}
        width={900}
        open={isOpen}
        onCancel={() => {
          setSpecifications(selectedItem?.specifications);
          setIsOpen(false);
        }}
        onOk={() => {
          dispatch(mainActions.addSpecification(specifications));
          setIsOpen(false);
        }}
        closable={false}
        okText={`${t("confirm")}`}
        cancelText={`${t("cancel")}`}
        destroyOnClose={true}
      >
        <Row>
          <Col span={24} className=" itemstyle">
            {t("item-specifications")}
          </Col>
        </Row>
        <Form layout="vertical">
          <Row gutter={[0, 20]}>
            <Col span={24} className=" ingredientstyle">
              ingredient 1 dwkcnkdancsc
            </Col>
            <Col span={6}>
              <Composition
                selectedItem={selectedItem}
                specifications={specifications}
                setSpecifications={setSpecifications}
              />
            </Col>
            <Col offset={1} span={10}>
              <Toppings
                selectedItem={selectedItem}
                specifications={specifications}
                setSpecifications={setSpecifications}
              />
            </Col>
            <Col offset={1} span={6}>
              <Prices extrasTotalPrice={extrasTotalPrice} />
            </Col>
            <Col span={24}>
              <Form.Item name="note" label="Note">
                <Input style={{ borderRadius: "16px" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default Item;
